import styled from "styled-components";

const VisualMainContainer = styled.div``;

export { VisualMainContainer };
